<template>
    <!-- a run of one team (10-2 in the last 3:12), or a team without a point for a while; next to the live score -->
    <v-row class="score-run px-0 py-1 rounded-xl" align="center" justify="center">
        <v-col cols="3" align="center" class="px-1 py-0 my-0">
            <img v-if="team.logo" :src="`${assetsUrl}/${team.logo}`" height="100px" width="auto" contain>
            <div :style="`width: 100%; border-top: 8px solid ${color};`" class="mt-2" />
        </v-col>
        <v-col cols="4" align="center" class="px-1 py-0 my-0">
            <div class="custom-orange-text font-weight-bold score-run__kicker">{{ kind === 'run' ? 'ΣΕΡΙ' : 'ΧΩΡΙΣ ΠΟΝΤΟ' }}</div>
            <div class="font-weight-bold score-run__value">{{ kind === 'run' ? `${points}-${against}` : time }}</div>
        </v-col>
        <v-col cols="5" class="px-2 py-0 my-0">
            <div class="font-weight-bold score-run__team">{{ team.name }}</div>
            <div class="score-run__detail">{{ detail }}</div>
            <div v-if="since" class="score-run__detail">{{ since }}</div>
        </v-col>
    </v-row>
</template>

<script>
    import { BACKGROUNDS, getMatchColors } from '@/utils/colors'
    import { formatSeconds, periodLabel } from '@/utils/scoreRun'

    export default {
        props: {
            match: {
                type: Object,
                required: true
            },
            // run: { kind: 'run', team (1 | 2), points, against, seconds (how long it lasts), fromPeriod (set when
            // it started in an earlier period) }; drought: { kind: 'drought', team, seconds, scored (false before
            // the first point of the team) }
            card: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        computed: {
            kind() {
                return this.card.kind
            },
            team() {
                return this.match[`team${this.card.team}`] || {}
            },
            // team colours that show on the black card and differ from each other
            color() {
                return getMatchColors(this.match.team1, this.match.team2, BACKGROUNDS.black)[`team${this.card.team}`]
            },
            points() {
                return this.card.points
            },
            against() {
                return this.card.against
            },
            time() {
                return formatSeconds(this.card.seconds)
            },
            detail() {
                if (this.kind === 'drought') {
                    return this.card.scored ? `για ${this.time} χρόνου αγώνα` : 'δεν έχει σκοράρει ακόμα'
                }
                return `τα τελευταία ${this.time}`
            },
            // the run started in an earlier period
            since() {
                return this.kind === 'run' && this.card.fromPeriod ? `από την ${periodLabel(this.card.fromPeriod)}` : ''
            }
        }
    }
</script>

<style scoped>
/* as tall as the live score next to it (its two rows and the line between them), top and bottom in line with
   it, and its gap from it the one of the other cards; the plain font of the scoreboard, easier to read than the
   one of the site */
.score-run {
    width: 670px;
    height: 203px;
    margin-left: 4px;

    /* the card area sits 3px higher than the scoreboard */
    position: relative;
    top: 3px;
    background-color: black;
    color: white;
    font-family: Ubuntu, Arial, sans-serif !important;
}

.score-run__kicker {
    font-size: 1.4rem;
    letter-spacing: 0.08em;
}

.score-run__value {
    font-size: 4rem;
    line-height: 1.1;
}

.score-run__team {
    font-size: 1.5rem;
    line-height: 1.2;
}

.score-run__detail {
    margin-top: 4px;
    font-size: 1.15rem;
    color: rgba(255, 255, 255, 0.8);
}
</style>
